<template>
  <div class="wave-vibration-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>v = λ / T = λf$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 混合渲染：波动图像 -->
      <div class="canvas-item">
         <div class="label">波动图像：时刻 t 时的空间分布</div>
         <svg width="100%" height="120" viewBox="0 0 400 120">
            <line x1="0" y1="60" x2="400" y2="60" stroke="rgba(255,255,255,0.1)" />
            <path :d="wavePath" fill="none" stroke="#00d2ff" stroke-width="2" />
            <!-- 特征点 P -->
            <circle :cx="pointPx" :cy="pointPy" r="4" fill="#ff4757" />
            <text :x="pointPx" :y="pointPy - 10" fill="#ff4757" font-size="10">P</text>
         </svg>
      </div>

      <!-- 振动图像 -->
      <div class="canvas-item">
         <div class="label">振动图像：质点 P 随时间的位移</div>
         <svg width="100%" height="120" viewBox="0 0 400 120">
            <line x1="0" y1="60" x2="400" y2="60" stroke="rgba(255,255,255,0.1)" />
            <path :d="vibrationPath" fill="none" stroke="#2ed573" stroke-width="2" />
            <circle cx="380" :cy="pointPy" r="4" fill="#ff4757" />
         </svg>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col">
                  <label>频率 f (Hz)</label>
                  <el-slider v-model="freq" :min="0.5" :max="3" :step="0.1" size="mini"></el-slider>
               </div>
               <div class="col">
                  <label>波速 v (m/s)</label>
                  <el-slider v-model="speed" :min="10" :max="100" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="hint-card">
            <p><strong>辨析：</strong>波动图像是“快照”，展示无数质点的集体状态；振动图像是“录像”，展示单个质点的时间心路历程。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaveVibrationViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      freq: 1,
      speed: 40,
      time: 0,
      pointPx: 150,
      running: true
    }
  },
  computed: {
    wavelength() { return this.speed / this.freq; },
    pointPy() {
       // y = A * sin(omega*t - k*x)
       const k = 2 * Math.PI / (this.wavelength * 2); // scale factor
       const omega = 2 * Math.PI * this.freq;
       return 60 - 40 * Math.sin(omega * this.time - k * this.pointPx);
    },
    wavePath() {
       let d = "M 0 60";
       const k = 2 * Math.PI / (this.wavelength * 2);
       const omega = 2 * Math.PI * this.freq;
       for(let x=0; x<=400; x+=2) {
          const y = 60 - 40 * Math.sin(omega * this.time - k * x);
          d += ` L ${x} ${y}`;
       }
       return d;
    },
    vibrationPath() {
       let d = "M 0 60";
       const k = 2 * Math.PI / (this.wavelength * 2);
       const omega = 2 * Math.PI * this.freq;
       // We show vibration of pointPx over last 5 seconds
       for(let t=0; t<=380; t+=2) {
          const pastT = this.time - (380 - t) * 0.01;
          const y = 60 - 40 * Math.sin(omega * pastT - k * this.pointPx);
          d += ` L ${t} ${y}`;
       }
       return d;
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; },
  methods: {
    animate() {
       if (!this.running) return;
       this.time += 0.016;
       requestAnimationFrame(this.animate);
    }
  }
}
</script>

<style scoped lang="scss">
.wave-vibration-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: rgba(0,0,0,0.3); border-radius: 12px; padding: 10px; border: 1px solid rgba(255,255,255,0.05);
   .label { font-size: 0.65rem; color: #888; margin-bottom: 8px; }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.hint-card { background: rgba(46, 213, 115, 0.05); padding: 12px 15px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
